// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wMS1","newExpiryDate":"styles_newExpiryDate__3vgZu","footer":"styles_footer__3nkyn"};